import React, { useEffect, useState } from "react";
import {
  Button,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  ListItem,
  ListItemText,
  ListItemIcon,
  Grid,
  TextField,
  DialogTitle,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AuthService from "../../../AuthService";
import { useSnackbar } from "notistack";

function CadastroCardapio(props) {
  const {
    open,
    setOpen,
    handleUpdateGrupo,
    handleListGrupos,
    grupos,
    state,
    setState,
  } = props;

  const { grupo, idTipoGrupo, erros } = state;

  const [optionsTipoGrupo, setOptionsTipoGrupo] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    handleList();
  }, []);

  const handleList = () => {
    const service = new AuthService();
    service
      .get("/tipoGrupoProduto/list")
      .then((res) => setOptionsTipoGrupo(res))
      .catch(console.error);
  };

  const handleDelete = (grupoToDelete) => {
    const service = new AuthService();
    service
      .delete(`/grupoProduto/inativar/${grupoToDelete.id}`)
      .then((retorno) => {
        const index = grupos.findIndex(
          (el) => el.grupoProduto.id === retorno.id
        );
        const updatedGrupos = [...grupos];
        updatedGrupos[index].grupoProduto = retorno;
        handleUpdateGrupo(updatedGrupos);

        enqueueSnackbar("Grupo inativado com sucesso", { variant: "info" });
      })
      .catch((err) => {
        if (err.response === undefined) {
          enqueueSnackbar("Falha ao tentar deletar o grupo", {
            variant: "error",
          });
        } else {
          err.response.json().then((elem) => {
            enqueueSnackbar("Falha ao deletar grupo " + elem.errorMessage, {
              variant: "error",
            });
          });
        }
      });
    setOpen(false);
  };

  const handleChange = (event) => {
    setState((prevState) => ({
      ...prevState,
      grupo: {
        ...prevState.grupo,
        [event.target.name]: event.target.value,
      },
    }));
  };

  const handleChangeTipoGrupoProduto = (event) => {
    const value = event.target.value;
    const tipoGrupoProduto = value ? { id: value } : null;

    setState((prevState) => ({
      ...prevState,
      idTipoGrupo: tipoGrupoProduto?.id || null,
      grupo: {
        ...prevState.grupo,
        tipoGrupoProduto: tipoGrupoProduto,
      },
    }));
  };

  const handleSubmit = (event) => {
    if (!grupo.descricao) {
      enqueueSnackbar("Preencha os campos requeridos", {
        variant: "warning",
      });

      setState((prevState) => ({
        ...prevState,
        erros: {
          ...prevState.erros,
          nomeGrupo: "O nome do grupo é obrigatório!",
        },
      }));

      return;
    }

    if (!grupo.tipoGrupoProduto.id) {
      grupo.tipoGrupoProduto.id = 23;
    }

    const service = new AuthService();
    service
      .post("/grupoProduto", grupo)
      .then(() => {
        if (erros.nomeGrupo) {
          setState((prevState) => ({
            ...prevState,
            erros: {
              ...prevState.erros,
              nomeGrupo: null,
            },
          }));
        }

        enqueueSnackbar("Grupo salvo com sucesso", { variant: "success" });
        handleListGrupos();
        setOpen(false);
      })
      .catch((err) => {
        setOpen(false);
        if (err.response === undefined) {
          enqueueSnackbar("Falha ao tentar salvar grupo", { variant: "error" });
        } else {
          err.response.json().then((elem) => {
            enqueueSnackbar("Falha ao salvar grupo " + elem.errorMessage, {
              variant: "error",
            });
          });
        }
      });
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Cadastro de grupos</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid
            size={{
              xs: 12,
              sm: 10,
            }}
          >
            <TextField
              variant="outlined"
              label="Nome do grupo"
              name="descricao"
              required
              sx={{ marginY: "0.5rem" }}
              error={!!erros.nomeGrupo}
              helperText={erros.nomeGrupo}
              fullWidth
              value={grupo.descricao || ""}
              onChange={handleChange}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 2,
            }}
          >
            <TextField
              variant="outlined"
              fullWidth
              label="Ordem"
              sx={{ marginY: "0.5rem" }}
              name="ordem"
              value={grupo.ordem || 0}
              onChange={handleChange}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              select
              label="Tipo do grupo"
              fullWidth
              variant="outlined"
              value={idTipoGrupo || 23}
              onChange={handleChangeTipoGrupoProduto}
              inputProps={{
                name: "tipoGrupoProduto",
                id: "tipo-do-grupo",
              }}
            >
              {optionsTipoGrupo.map((tipo) => (
                <MenuItem key={tipo.id} value={tipo.id}>
                  <ListItem style={{ padding: "0" }}>
                    <ListItemIcon>
                      <img
                        alt="icone-grupo"
                        style={{ maxWidth: "32px" }}
                        src={`https://app.qrpedir.com/assets/images/iconsLinesColor/${tipo.imagem}`}
                      />
                    </ListItemIcon>
                    <ListItemText primary={tipo.descricao} />
                  </ListItem>
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={!grupo.id}
          variant="text"
          startIcon={<DeleteIcon />}
          onClick={() => handleDelete(grupo)}
        >
          EXCLUIR
        </Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          SALVAR
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CadastroCardapio;
